import React from 'react';
import {Link} from 'react-router-dom';
import DivisionsByMode from '../Widgets/DivisionsByMode';
import Leagues from '../Widgets/Leagues';
import LeaguesByStatus from '../Widgets/LeaguesByStatus';
import LeaguesRestart from '../Widgets/LeaguesRestart';

// import LeaguesReactivated from '../Widgets/LeaguesReactivated';

export default () => (
  <div id="statistics-leagues">
    <header className="content-header">
      <h1>
        Statistics
        <small>Leagues</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/statistics/leagues">Leagues</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-lg-6">
          <Leagues />
          <LeaguesByStatus />
        </div>
        <div className="col-lg-6">
          <LeaguesRestart />
          <DivisionsByMode />
          {/*<LeaguesReactivated />*/}
        </div>
      </div>
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Leagues/index.js